import styled from "styled-components";
import {Input} from "reakit";


export const Datetime = styled(Input)`
  background: none;
  //border-bottom: 1px solid #969a9b;
`;